import { Hidden, IconButton, Toolbar }      from "@material-ui/core";
import { Menu }                             from "@material-ui/icons";
import * as React                           from "react";
import { FC, useEffect }                    from "react";
import { useDispatch }                      from "react-redux";
import { useHistory }                       from "react-router";
import { Header, Icon, Popup, Segment }     from "semantic-ui-react";
import GetCountRequestedCancelStatus
                                            from "../../../application/usecase/reservation/cancel/GetCountRequestedCancelStatus";
import GlobalDispatcher                     from "../../../infrastructure/redux/global/GlobalDispatcher";
import { useReservationCancelRequestCount } from "../../../infrastructure/redux/reservation/cancel";
import "./ResKaHeader.scss";

interface Props {
  headerTitle: string;
  dispatcher: GlobalDispatcher;
}

const ResKaHeader: FC<Props> = (props: Props) => {
  const {headerTitle, dispatcher} = props;
  const count = useReservationCancelRequestCount();
  const getCountRequestedCancelStatus = new GetCountRequestedCancelStatus(useDispatch());
  const history = useHistory();

  useEffect(() => {
    getCountRequestedCancelStatus.execute();
  }, []);

  return (
    <>
      <Hidden smDown={ true }>
        <Segment className="reska-header reska-header-md" clearing={ true }>
          <Header className="reska-header-content">
            <Header.Content className="reska-header-content reska-header-content-md reska-header-title">
              { headerTitle }
            </Header.Content>
          </Header>

          <section style={ {display: "flex", justifyContent: "flex-end", width: "100%"} }>
            <Header
              className="reska-header-content reska-header-content-menu"
              onClick={ () => history.push("/reservation/cancel/requests") }
            >
              <Popup
                content="未処理の予約キャンセル依頼数です。"
                trigger={
                  <Icon
                    size="tiny"
                    name={ count.isEmpty() ? "bell outline" : "bell" }
                    color={ count.isEmpty() ? "black" : "red" }
                  />
                }
              />
              <Header.Content
                className="reska-header-content reska-header-content-md"
              >
                { count.toString() }
              </Header.Content>
            </Header>
            <Header
              className="reska-header-content reska-header-content-menu"
              onClick={ () => window.open("https://marespera.atlassian.net/wiki/spaces/ResKaManual") }
            >
              <Icon name="help circle" size="tiny"/>
              <Header.Content
                className="reska-header-content reska-header-content-md"
              >
                マニュアル
              </Header.Content>
            </Header>
            <Header
              className="reska-header-content reska-header-content-menu reska-header-content-menu-last"
              onClick={ () => window.location.href = "/logout" }
            >
              <Icon name="log out" size="tiny"/>
              <Header.Content
                className="reska-header-content reska-header-content-md"
              >
                ログアウト
              </Header.Content>
            </Header>
          </section>
        </Segment>
      </Hidden>

      <Hidden mdUp={ true }>
        <Segment className="reska-header reska-header-sm" clearing={ true }>
          <Toolbar className="reska-header-toolbar">
            <IconButton onClick={ () => dispatcher.toggleSpMenu() }>
              <Menu/>
            </IconButton>
          </Toolbar>
          <Header className="reska-header-content">
            <Header.Content className="reska-header-content reska-header-content-sm reska-header-title">
              { headerTitle }
            </Header.Content>
          </Header>

          <section style={ {display: "flex", justifyContent: "flex-end", width: "100%"} }>
            <Header
              className="reska-header-content reska-header-content-menu"
              onClick={ () => history.push("/reservation/cancel/requests") }
            >
              <Popup
                content="未処理の予約キャンセル依頼数です。"
                trigger={
                  <Icon
                    size="tiny"
                    name={ count.isEmpty() ? "bell outline" : "bell" }
                    color={ count.isEmpty() ? "black" : "red" }
                  />
                }
              />
              <Header.Content
                className="reska-header-content reska-header-content-md"
              >
                { count.toString() }
              </Header.Content>
            </Header>
            <Header
              className="reska-header-content reska-header-content-menu"
              onClick={ () => window.open("https://marespera.atlassian.net/wiki/spaces/ResKaManual") }
            >
              <Icon name="help circle" size="tiny"/>
            </Header>
            <Header
              className="reska-header-content reska-header-content-menu reska-header-content-menu-last"
              onClick={ () => window.location.href = "/logout" }
            >
              <Icon name="log out" size="tiny"/>
            </Header>
          </section>
        </Segment>
      </Hidden>
    </>
  );
};

export default ResKaHeader;
